import { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

import styles from "./styles.module.css";
import search from "../../../assets/images/search.png";
import { BASE_URL } from "../../../utils/constants";
import axios from "axios";
import Spinner from "../../../components/spinner";
import Table from "../../../components/table";
import Button from "../../../components/button-v1";
import Tooltip from "../../../components/shared-modules/Tooltip";
import { getAllStatuses } from "../../../services/admin/statuses";
import { FaPlus } from "react-icons/fa";
import { Filter } from "lucide-react";
import { handleApiError } from "../../../utils/handleApiError";
import FilterPanel from "../../../components/shared-modules/FilterDrawer/FilterDrawer";
import FilterBuilder from "../../../components/shared-modules/filter";
import { applyFilters } from "../../../components/shared-modules/filter/utils";
import { getLocationList } from "../../../services/admin/organization";
import { useQuery } from "@tanstack/react-query";
import useRoles from "../../../hooks/useRoles";
import { Dropdown, DropdownItem } from "../../../components/ui/dropdown";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui/popover";
import { formatDate } from "../../../utils/helper";
import { getUserIdentity } from "../../../utils/authorization";
const dashboardFiltersConfig = [
  {
    label: "patient_name",
    value: "patient_name",
    type: "text",
    operators: ["contains", "is_empty", "is_not_empty"],
  },

  // {
  //   label: "Stat  // {
  //   label: "Status",
  //   value: "status",
  //   type: "text",
  //   operators: [
  //     "equals",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },us",
  //   value: "status",
  //   type: "text",
  //   operators: [
  //     "equals",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },

  {
    label: "Case Manager",
    value: "case_manager_name",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Provider",
    value: "provider_name",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Language",
    value: "preferred_language",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Location",
    value: "patient_location",
    type: "text",
    operators: ["contains", "is_empty", "is_not_empty"],
  },
  {
    label: "CCM",
    value: "ccm",
    type: "boolean",
    operators: ["is_true", "is_false"],
  },
  // {
  //   label: "RPM",
  //   value: "rpm",
  //   type: "boolean",
  //   operators: ["is_true", "is_false"],
  // },
  // {
  //   label: "Reading Days",
  //   value: "reading_days_current_month",
  //   type: "number",
  //   operators: ["equals", "greater_than", "less_than"],
  // },
  // {
  //   label: "RPM Time (mins)",
  //   value: "rpm_time_in_minutes",
  //   type: "number",
  //   operators: ["greater_than", "less_than"],
  // },
  {
    label: "CCM Time (mins)",
    value: "ccm_time_in_minutes",
    type: "number",
    operators: ["greater_than", "less_than"],
  },
];

const nurseFilterConfig = [
  {
    label: "Careplan Status",
    value: "care_plan_status",
    type: "text",
    operators: ["contains", "is_empty", "is_not_empty"],
  },
];

const CareManagerDashboard = () => {
  const { roles, position } = useRoles();
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("nurse_pt_tab") || "my_all_patients";
  });
  const [selectedProgram, setselectedProgram] = useState(
    sessionStorage.getItem("nurse_selectedProgram") || "all_patients"
  );
  const [allPatientCount, setAllPatientCount] = useState(null);
  const [nameSearch, setNameSearch] = useState("");
  const [providerSearch, setProviderSearch] = useState("");
  const navigate = useNavigate();
  const [statuses, setStatuses] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [statusesLoading, setStatusesLoading] = useState(false);
  const [activeWorkflow, setActiveWorkflow] = useState(() => {
    return sessionStorage.getItem("nurse_active_workflow") || "my_all_patients";
  });
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  // GENERAL FILTER
  const [filters, setFilters] = useState([]);

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const location_id = JSON.parse(sessionStorage.getItem("current_loc"))?.id;
  const is_patient =
    JSON.parse(localStorage.getItem("user"))?.type === "patient" ? true : false;

  const user = JSON.parse(localStorage.getItem("user"));

  const isOutOfRange = (patient) => {
    return patient.out_of_range === true;
  };

  const isMonitoringSessionWorkflow = (patient) => {
    return patient.monitoring_session === true;
  };

  const isUnseenReadings = (patient) => {
    return patient.unseen_readings === true;
  };

  const isReadingReminder = (patient) => {
    return patient.reading_reminder === true;
  };

  const handleProgramSelect = (program) => {
    setselectedProgram(program);
    sessionStorage.setItem("nurse_selectedProgram", program);
  };

  // FILTERS
  let filterConfig;

  if (position === "Nurse") {
    filterConfig = [...dashboardFiltersConfig, ...nurseFilterConfig];
  } else {
    filterConfig = dashboardFiltersConfig;
  }

  const workflows = [
    {
      id: "out_of_range",
      label: "Out of Range",
      tooltip:
        "Patient that have unresolved out of range readings. Address by resolving any out of range readings on these patients.",
      filterFunction: isOutOfRange,
    },
    {
      id: "monitoring_session",
      label: "Monitoring Session",
      tooltip:
        "It has been at least 2 days since time was monitored and these patients have less than 20 minutes logged. Address by spending time Conviewing these patients' 87 readings & data.",
      filterFunction: isMonitoringSessionWorkflow,
    },
    {
      id: "unseen_readings",
      label: "Unseen Readings",
      tooltip:
        "Patients that have unseen readings.Address by logging any amount of monitoring time for these patients. View their new reading",
      filterFunction: isUnseenReadings,
    },
    {
      id: "reading_reminder",
      label: "Reading Reminder",
      tooltip:
        "Patients who are off track and have not receive a reading in the last 3 days. Address by logging some sort of communication with each patient.",
      filterFunction: isReadingReminder,
    },
  ];

  // Filtering the patients based on the selected KPIs
  // This is used to display the number of patients in each workflow
  const workflowData = useMemo(() => {
    // const patientList = patients?.patients || [];
    let patientList = patients?.patients || patients?.assigned_patients || [];

    const filteredList = patientList?.filter((patient) => {
      if (selectedProgram === "all_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "rpm_patients") {
        return patient.rpm;
      } else if (selectedProgram === "ccm_patients") {
        return patient.ccm;
      } else if (selectedProgram === "pending_review") {
        return (
          patient.care_plan_status !== "Finalized" &&
          patient.care_plan_status !== null
        );
      } else if (selectedProgram === "finalized_review") {
        return patient.care_plan_status === "Finalized";
      } else if (selectedProgram === "active_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "compliant_patients") {
        return patient.is_compliant;
      }
      return false;
    });

    const rpmPatients = filteredList?.filter((patient) => patient?.rpm);

    const data = {};

    workflows.forEach((workflow) => {
      const filteredPatients = rpmPatients?.filter(workflow.filterFunction);
      data[workflow.id] = {
        count: filteredPatients.length,
        patientIds: filteredPatients.map((p) => p.id),
      };
    });

    return data;
  }, [patients, selectedProgram]);

  useEffect(() => {
    let patientList = patients?.patients || patients?.assigned_patients || [];

    const filteredList = patientList?.filter((patient) => {
      if (selectedProgram === "all_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "rpm_patients") {
        return patient.rpm;
      } else if (selectedProgram === "ccm_patients") {
        return patient.ccm;
      } else if (selectedProgram === "compliant_patients") {
        return patient.is_compliant;
      } else if (selectedProgram === "active_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "pending_review") {
        return (
          patient.care_plan_status !== "Finalized" &&
          patient.care_plan_status !== null
        );
      } else if (selectedProgram === "finalized_review") {
        return patient.care_plan_status === "Finalized";
      }
    });
  }, [activeTab, patients, workflowData, selectedProgram]);

  const handlePatientClick = (patient) => {
    sessionStorage.setItem("_pt_id", patient.id);
    const ccm = Number(patient.ccm);
    const rpm = Number(patient.rpm);

    sessionStorage.setItem("_dash", "nurse");
    navigate(
      `/patient/details/?patient_id=${patient.id}&CCM=${ccm}&RPM=${rpm}`
    );
  };

  useEffect(() => {
    let patientList = patients?.patients || patients?.assigned_patients || [];

    const filteredList = patientList?.filter((patient) => {
      if (selectedProgram === "all_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "rpm_patients") {
        return patient.rpm;
      } else if (selectedProgram === "ccm_patients") {
        return patient.ccm;
      } else if (selectedProgram === "active_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "compliant_patients") {
        return patient.is_compliant;
      } else if (selectedProgram === "active_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "pending_review") {
        return (
          patient.care_plan_status !== "Finalized" &&
          patient.care_plan_status !== null
        );
      } else if (selectedProgram === "finalized_review") {
        return patient.care_plan_status === "Finalized";
      }
      return false;
    });

    setAllPatientCount(filteredList?.length || 0);
  }, [selectedProgram]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const staffId = JSON.parse(localStorage.getItem("user"))?.staff_id;
    const fetchPatients = async () => {
      let url = null;
      const isNurse = getUserIdentity(user)?.isNurse;
      
      if (isNurse) {
        url = `${BASE_URL}/patients/${account_id}/${staffId}/staff-patients/?nurse_patients=true`;
      } else if (!roles.includes("Case Manager")) {
        url = `${BASE_URL}/patients/${account_id}/${location_id}/patients/`;
      } else {
        url = `${BASE_URL}/patients/${account_id}/${user?.staff_id}/staff-patients/`;
        // url = `${BASE_URL}/patients/${account_id}/42/staff-patients/`
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        // full list (nurse table renders all rows; endpoint paginates by default now)
        params: { pagination: "false" },
      });
      return response.data;
    };

    const fetchAllData = async () => {
      try {
        const [patientData] = await Promise.all([fetchPatients()]);
        setPatients(patientData);
        setAllPatientCount(patientData?.patient_count || 0);
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    const fetchStatuses = async () => {
      setStatusesLoading(true);
      try {
        const statusData = await getAllStatuses();
        setStatuses(statusData || []);
      } catch (error) {
        handleApiError(error);
      } finally {
        setStatusesLoading(false);
      }
    };

    fetchStatuses();
  }, []);

  const filteredData = useMemo(() => {
    let patientList = [];

    patientList = patients?.patients || patients?.assigned_patients || [];
    let baseFilteredList = [];

    if (activeTab === "my_all_patients") {
      baseFilteredList = patientList;
    } else {
      const workflowConfig = workflows.find((w) => w.id === activeTab);
      if (workflowConfig) {
        baseFilteredList = patientList
          .filter(workflowConfig.filterFunction)
          .filter((patient) => patient.rpm);
      }
    }

    const filteredPatients = baseFilteredList.filter((patient) => {
      if (selectedProgram === "all_patients") {
        return patient.rpm || patient.ccm;
      } else if (selectedProgram === "rpm_patients") {
        return patient.rpm;
      } else if (selectedProgram === "ccm_patients") {
        return patient.ccm;
      } else if (selectedProgram === "compliant_patients") {
        return patient.is_compliant;
      } else if (selectedProgram === "pending_review") {
        return (
          patient.care_plan_status !== "Finalized" &&
          patient.care_plan_status !== null
        );
      } else if (selectedProgram === "finalized_review") {
        return patient.care_plan_status === "Finalized";
      } else if (selectedProgram === "active_patients") {
        return patient.rpm || patient.ccm;
      }
      return false;
    });

    const searchedAndSorted = filteredPatients
      .filter((row) => {
        const fullName = `${row.first_name} ${row.last_name}`.toLowerCase();
        const nameMatch = fullName.includes(nameSearch.toLowerCase());

        if (activeFilters.length > 0) {
          const selectedStatusNames = activeFilters
            .map((filterId) => {
              const status = statuses.find((s) => s.id === filterId);
              return status ? status.name : null;
            })
            .filter(Boolean);

          return (
            nameMatch &&
            row.statuses &&
            row.statuses.some((statusObj) => {
              return selectedStatusNames.includes(statusObj.status);
            })
          );
        }

        return nameMatch;
      })
      .sort((a, b) => {
        if (a.last_name && b.last_name) {
          return a.last_name.localeCompare(b.last_name);
        }
        return 0;
      });

    // Serialized the data for filters
    searchedAndSorted.forEach((patient) => {
      if (patient.case_manager && typeof patient.case_manager === "object") {
        const first = patient.case_manager.first_name || "";
        const last = patient.case_manager.last_name || "";
        patient.case_manager_name = `${first} ${last}`.trim();
      } else {
        patient.case_manager_name = "";
      }

      if (patient.provider && typeof patient.provider === "object") {
        const first = patient.provider.first_name || "";
        const last = patient.provider.last_name || "";
        patient.provider_name = `${first} ${last}`.trim();
      } else {
        patient.provider_name = "";
      }

      if (patient.first_name && patient.last_name) {
        patient.patient_name =
          `${patient.first_name} ${patient.last_name}`.trim();
      } else {
        patient.patient_name = "";
      }

      if (patient.location && typeof patient.location === "object") {
        const name = patient.location.name || "";
        patient.patient_location = name;
      } else {
        patient.patient_location = "";
      }

      if (patient.total_ccm_seconds && patient.total_ccm_seconds > 0) {
        patient.ccm_time_in_minutes = Math.floor(
          patient.total_ccm_seconds / 60
        );
      } else {
        patient.ccm_time_in_minutes = 0;
      }

      if (patient.total_rpm_seconds && patient.total_rpm_seconds > 0) {
        patient.rpm_time_in_minutes = Math.floor(
          patient.total_rpm_seconds / 60
        );
      } else {
        patient.rpm_time_in_minutes = 0;
      }
    });

    return applyFilters(searchedAndSorted, filters);
  }, [
    patients,
    activeTab,
    nameSearch,
    activeFilters,
    statuses,
    workflowData,
    selectedProgram,
    filters,
  ]);

  const handleFilterClick = (statusId) => {
    if (activeFilters.includes(statusId)) {
      setActiveFilters(activeFilters.filter((id) => id !== statusId));
    } else {
      setActiveFilters([...activeFilters, statusId]);
    }
  };

  const handleClearFilters = () => {
    setActiveFilters([]);
  };

  const getCaseManagerName = (caseManager) => {
    if (!caseManager) return "--";
    return `${caseManager.first_name} ${caseManager.last_name}`;
  };

  const getProviderName = (provider) => {
    if (!provider) return "--";
    return `${provider.first_name} ${provider.last_name}`;
  };

  const getLastReading = (reading) => {
    if (reading === null || reading === undefined) return "--";
    if (reading === 0) {
      return <span style={{ color: "#63c132" }}>Today</span>;
    }
    if (reading === 1) {
      return <span style={{ color: "#63c132" }}>Yesterday</span>;
    }
    return `${reading} days ago`;
  };

  const patientTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      sorting: true,
      render: (row) => (
        <div className={styles.name_with_info}>
          {`${row.first_name} ${row.last_name}`}
          {row.quick_notes && (
            <Tooltip content={row.quick_notes} position="right">
              <span className={styles.info_icon}>i</span>
            </Tooltip>
          )}
        </div>
      ),
    },
    // {
    //   key: "statuses",
    //   label: "Statuses",
    //   alignLeft: true,
    //   render: (row) => {
    //     if (!row.statuses || row.statuses.length === 0) {
    //       return "_ _";
    //     }

    //     return (
    //       <div className={styles.patient_status_container}>
    //         {row.statuses.map((status, index) => (
    //           <div
    //             key={index}
    //             className={
    //               status.is_default
    //                 ? styles.patient_default_status
    //                 : styles.patient_status_item
    //             }
    //             style={{}}
    //           >
    //             <span className={styles.patient_status_tag}>
    //               {status.status}
    //               {status.description && (
    //                 <Tooltip content={status.description} position="right">
    //                   <span className={styles.status_icon}>?</span>
    //                 </Tooltip>
    //               )}
    //             </span>
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    {
      key: "case_manager_name",
      label: "Case Manager",
      // render: (row) => getCaseManagerName(row.case_manager),
      alignLeft: true,
    },
    {
      key: "provider",
      label: "Provider",
      render: (row) => getProviderName(row.provider),
      alignLeft: true,
    },
    {
      key: "patient_location",
      label: "Location",
      render: (row) => row.patient_location,
      alignLeft: true,
    },
    {
      key: "prefered_lenguage",
      label: "Language",
      render: (row) => row.preferred_language,
      alignLeft: true,
    },
    {
      key: "formatted_ccm_time",
      label: "CCM Time",
      render: (row) => row.formatted_ccm_time,
      alignLeft: true,
    },
    // {
    //   key: "formatted_rpm_time",
    //   label: "RPM Time",
    //   render: (row) => row.formatted_rpm_time,
    //   alignLeft: true,
    // },
    // {
    //   key: "reading_days_current_month",
    //   label: "Reading Days",
    //   render: (row) => row.reading_days_current_month,
    // },
    // {
    //   key: "days_since_last_reading",
    //   label: "Last Reading",
    //   render: (row) => getLastReading(row.days_since_last_reading),
    //   alignLeft: true,
    // },
    // {
    //   key: "device_status",
    //   label: "Device Status",
    //   sorting: false,
    //   alignLeft: true,
    //   render: (row) => {
    //     const status = row.device_status;

    //     const getStyle = (status) => {
    //       const baseStyle = {
    //         padding: "4px 12px",
    //         borderRadius: "25px",
    //         textAlign: "center",
    //         display: "inline-flex",
    //         alignItems: "center",
    //         gap: "10px",
    //         justifyContent: "center",
    //         fontSize: "14px",
    //         fontWeight: "500",
    //       };

    //       if (status === "Assigned") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#D4EEE0",
    //           color: "#1A5D3D",
    //         };
    //       } else if (status === "Needs readings") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#B6DAFC",
    //           color: "#1B4F72",
    //         };
    //       } else if (status === "None") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#F9F1D9",
    //           color: "#7E6513",
    //         };
    //       }
    //       return { ...baseStyle, backgroundColor: "#eee", color: "#333" };
    //     };

    //     const getDotColor = (status) => {
    //       if (status === "Assigned") return "#178D5A";
    //       if (status === "Needs readings") return "#2874A6";
    //       if (status === "None") return "#B7950B";
    //       return "#666";
    //     };

    //     return (
    //       <>
    //         {row.ccm === true && row.rpm === false ? (
    //           <span>--</span>
    //         ) : (
    //           <span style={getStyle(status)}>
    //             <span
    //               style={{
    //                 width: "8px",
    //                 height: "8px",
    //                 backgroundColor: getDotColor(status),
    //                 borderRadius: "50%",
    //               }}
    //             ></span>
    //             <span>{status}</span>
    //           </span>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   key: "program",
    //   label: "Program",
    //   render: (row) =>
    //     row.rpm && row.ccm
    //       ? "RPM | CCM"
    //       : row.rpm
    //       ? "RPM"
    //       : row.ccm
    //       ? "CCM"
    //       : "None",
    // },
  ];

  const nurseTabColumns = [
    {
      key: "careplan_status",
      label: "Careplan Status",
      alignLeft: true,
      render: (row) => {
        if (!row.care_plan_status) {
          return "_ _";
        }

        return (
          <div className={styles.patient_status_container}>
            <div
              // className={
              //   status.is_default
              //     ? styles.patient_default_status
              //     : styles.patient_status_item
              // }
              className={styles.patient_status_item}
            >
              <span className={styles.patient_status_tag}>
                {/* {status.status} */}
                {/* {status.description && (
                    <Tooltip content={status.description} position="right">
                      <span className={styles.status_icon}>?</span>
                    </Tooltip>
                  )} */}
                {row.care_plan_status}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      key: "careplan_assigned_date",
      label: "Assigned Date",
      render: (row) => formatDate(row.care_plan_assigned_date),
      alignLeft: true,
    },
    {
      key: "careplan_finalized_date",
      label: "Finalized Date",
      render: (row) => formatDate(row.care_plan_finalized_date),
      alignLeft: true,
    },
  ];

  let tableColumns = patientTableColumns;

  if (position === "Nurse") {
    tableColumns = [...tableColumns, ...nurseTabColumns];
  }

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    sessionStorage.setItem("nurse_pt_tab", tabId);
    sessionStorage.setItem("_active_workflow", tabId);

    if (tabId === "my_all_patients") {
      sessionStorage.setItem("_workflow_name", "All Patients");
    } else {
      const workflow = workflows.find((w) => w.id === tabId);
      sessionStorage.setItem(
        "_workflow_name",
        workflow?.label || "Unknown Workflow"
      );
    }
  };

  const getWorkflowAwareMetrics = useMemo(() => {
    let allPatients = patients?.patients || patients?.assigned_patients || [];

    const filteredPatients = allPatients;

    return {
      totalPatients:
        filteredPatients?.length + patients?.deactivated_patient_count ?? 0,

      rpmPatients: filteredPatients.filter((patient) => patient.rpm).length,
      ccmPatients: filteredPatients.filter((patient) => patient.ccm).length,
      compliantPatients: filteredPatients.filter(
        (patient) => patient.is_compliant
      ).length,
      newPatients: filteredPatients.filter((patient) => {
        const createdDate = patient.created_at
          ? new Date(patient.created_at)
          : null;
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        return createdDate && createdDate > thirtyDaysAgo;
      }).length,
      pendingCareplans: patients?.total_pending_care_plans,
      finalizedCareplans: patients?.total_finalized_care_plans,
      deactivated_patient_count: patients?.deactivated_patient_count,
      active_patient_count: filteredPatients?.length ?? 0,
    };
  }, [patients]);

  const getWorkflowCompletionPercentages = useMemo(() => {
    const allPatients = patients?.patients || [];
    const totalPatients = allPatients.length;

    if (totalPatients === 0) return {};

    const percentages = {};

    workflows.forEach((workflow) => {
      const workflowPatients = workflowData[workflow.id]?.count || 0;
      const completedPatients = totalPatients - workflowPatients;
      const completionPercentage = Math.round(
        (completedPatients / totalPatients) * 100
      );

      percentages[workflow.id] = {
        completed: completedPatients,
        total: totalPatients,
        percentage: completionPercentage,
      };
    });

    return percentages;
  }, [patients, workflowData]);

  return (
    <div className={styles.patient_page}>
      <div className={styles.patient_page_container}>
        {!is_patient && (
          <>
            {loading ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                {/* Dashboard Metrics */}

                {/* Patient Table Section */}
                <div className={styles.patient_wrapper}>
                  {/* <div className={styles.top}>
                    <p className={styles.heading}>Patients </p>

                    {!roles.includes("Case Manager") && (
                      <div className={styles.top_buttons}>
                        <Link
                          to={location_id && "/patient/create-patient"}
                          className={styles.top_btn}
                        >
                          <Button variant="primary" size="default">
                            <FaPlus size="10px" />
                            Add Patient
                          </Button>
                        </Link>
                      </div>
                    )}
                  </div> */}

                  {/* Workflow Tabs */}
                  {/* <div className={styles.toggle_wrapper}>
                    <p
                      className={`${styles.patient_toggle} ${
                        activeTab === "my_all_patients" ? styles.active : ""
                      }`}
                      onClick={() => handleTabChange("my_all_patients")}
                    >
                      All Patients ({allPatientCount})
                    </p>

                    {workflows.map((workflow) => (
                      <div key={workflow.id}>
                        <p
                          className={`${styles.patient_toggle} ${
                            activeTab === workflow.id ? styles.active : ""
                          }`}
                          onClick={() => handleTabChange(workflow.id)}
                        >
                          <Tooltip content={workflow.tooltip} position="top">
                            <span className={styles.info_icon}> ? </span>
                          </Tooltip>
                          {workflow.label} (
                          {workflowData[workflow.id]?.count || 0})
                        </p>
                      </div>
                    ))}
                  </div> */}

                  {/* Table Container */}
                  {(activeTab === "my_all_patients" ||
                    workflows.some((w) => w.id === activeTab)) && (
                    <div className={styles.table_container}>
                      {/* Search and Filter Controls */}
                      <div
                        className={styles.searchbar_container}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        {/* KPIs */}
                        <div className={styles.dashboard_wrapper}>
                          <div
                            className={styles.dash_item}
                            onClick={() =>
                              handleProgramSelect("active_patients")
                            }
                            style={{
                              border:
                                selectedProgram === "active_patients"
                                  ? "2px solid var(--primary)"
                                  : "",
                              backgroundColor:
                                selectedProgram === "active_patients"
                                  ? "#E9F5FF"
                                  : "",
                            }}
                          >
                            <p className={styles.heading}>Assigned Patients</p>
                            <p className={styles.quantity}>
                              {getWorkflowAwareMetrics.active_patient_count}
                            </p>
                          </div>

                          <div
                            className={styles.dash_item}
                            onClick={() => handleProgramSelect("ccm_patients")}
                            style={{
                              border:
                                selectedProgram === "ccm_patients"
                                  ? "2px solid var(--primary)"
                                  : "",
                              backgroundColor:
                                selectedProgram === "ccm_patients"
                                  ? "#E9F5FF"
                                  : "",
                            }}
                          >
                            <p className={styles.heading}>CCM Patients</p>
                            <p className={styles.quantity}>
                              {getWorkflowAwareMetrics.ccmPatients}
                            </p>
                          </div>
                          {/* 
                          <div
                            onClick={() =>
                              handleProgramSelect("compliant_patients")
                            }
                            style={{
                              border:
                                selectedProgram === "compliant_patients"
                                  ? "2px solid var(--primary)"
                                  : "",
                              backgroundColor:
                                selectedProgram === "compliant_patients"
                                  ? "#E9F5FF"
                                  : "",
                            }}
                            className={styles.dash_item}
                          >
                            <p className={styles.heading}>Compliant Patients</p>
                            <p className={styles.quantity}>
                              {" "}
                              {getWorkflowAwareMetrics.compliantPatients}
                            </p>
                          </div> */}

                          <div
                            className={styles.dash_item}
                            onClick={() =>
                              handleProgramSelect("pending_review")
                            }
                            style={{
                              border:
                                selectedProgram === "pending_review"
                                  ? "2px solid var(--primary)"
                                  : "",
                              backgroundColor:
                                selectedProgram === "pending_review"
                                  ? "#E9F5FF"
                                  : "",
                            }}
                          >
                            <p className={styles.heading}>
                              Pending Finalization
                            </p>
                            <p className={styles.quantity}>
                              {getWorkflowAwareMetrics.pendingCareplans}
                            </p>
                          </div>
                          <div
                            className={styles.dash_item}
                            onClick={() =>
                              handleProgramSelect("finalized_review")
                            }
                            style={{
                              border:
                                selectedProgram === "finalized_review"
                                  ? "2px solid var(--primary)"
                                  : "",
                              backgroundColor:
                                selectedProgram === "finalized_review"
                                  ? "#E9F5FF"
                                  : "",
                            }}
                          >
                            <p className={styles.heading}>
                              Finalized Care Plans
                            </p>
                            <p className={styles.quantity}>
                              {getWorkflowAwareMetrics.finalizedCareplans}
                            </p>
                          </div>

                          {/* <div
                    className={styles.dash_KPI}
                    // onClick={() => handleProgramSelect("all_patients")}
                    // style={{
                    //   border:
                    //     selectedProgram === "all_patients"
                    //       ? "2px solid var(--primary)"
                    //       : "",
                    //   backgroundColor:
                    //     selectedProgram === "all_patients" ? "#E9F5FF" : "",
                    // }}
                  >
                    <p className={styles.heading}>Total Patients</p>
                    <p className={styles.quantity}>
                      {getWorkflowAwareMetrics.totalPatients}
                    </p>
                  </div>

                  <div
                    className={styles.dash_KPI}
                    // onClick={() => handleProgramSelect("active_patients")}
                    // style={{
                    //   border:
                    //     selectedProgram === "all_patients"
                    //       ? "2px solid var(--primary)"
                    //       : "",
                    //   backgroundColor:
                    //     selectedProgram === "all_patients" ? "#E9F5FF" : "",
                    // }}
                  >
                    <p className={styles.heading}>In-Active Patients</p>
                    <p className={styles.quantity}>
                      {getWorkflowAwareMetrics.deactivated_patient_count}
                    </p>
                  </div> */}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            alignItems: "center",
                          }}
                        >
                          <div className={styles.input_wrapper}>
                            <input
                              type="text"
                              placeholder="Search by Name"
                              value={nameSearch}
                              onChange={(e) => setNameSearch(e.target.value)}
                            />
                            <img alt=" " src={search || "/placeholder.svg"} />
                          </div>

                          {/* <button
                            className={`${styles.filter_trigger_button} ${
                              activeFilters.length > 0 ? styles.active : ""
                            }`}
                            onClick={() =>
                              setIsFilterPanelOpen(!isFilterPanelOpen)
                            }
                          >
                            <Filter size={12} />
                            Status Filters
                            {activeFilters.length > 0 && (
                              <span
                                style={{
                                  backgroundColor: "var(--primary)",
                                  color: "#DBEAF8",
                                  borderRadius: "10px",
                                  padding: "4px 4px",
                                  fontSize: "10px",
                                  minWidth: "18px",
                                  textAlign: "center",
                                }}
                              >
                                {activeFilters.length}
                              </span>
                            )}
                          </button> */}

                          {/* GENERAL FILTER */}
                          <Popover>
                            <PopoverTrigger>
                              <button
                                className={`${styles.filter_trigger_button} ${
                                  activeFilters.length > 0 ? styles.active : ""
                                }`}
                              >
                                <Filter size={12} />
                                Advance Filters
                                {filters.length > 0 && (
                                  <span
                                    style={{
                                      backgroundColor: "var(--primary)",
                                      color: "#DBEAF8",
                                      borderRadius: "10px",
                                      padding: "4px 4px",
                                      fontSize: "10px",
                                      minWidth: "18px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {filters.length}
                                  </span>
                                )}
                              </button>
                            </PopoverTrigger>
                            <PopoverContent
                              sideOffset={5}
                              defaultCloseBtn
                              align="center"
                              className={styles.filter_container}
                            >
                              <FilterBuilder
                                fieldConfig={filterConfig}
                                initialFilters={filters}
                                onChange={handleFiltersChange}
                              />
                            </PopoverContent>
                          </Popover>

                          {/* {activeFilters.length > 0 && (
                            <button
                              className={styles.clear_all_button}
                              onClick={handleClearFilters}
                            >
                              Clear All
                            </button>
                          )} */}
                        </div>

                        {/* {activeTab !== "my_all_patients" &&
                          getWorkflowCompletionPercentages[activeTab] && (
                            <div
                              className={styles.workflow_completion_display}
                              style={{
                                minWidth: "300px",
                              }}
                            >
                              <div style={{ marginBottom: "8px" }}>
                                <span
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "700",
                                    color: "#1a1a1a",
                                    marginRight: "8px",
                                  }}
                                >
                                  {
                                    getWorkflowCompletionPercentages[activeTab]
                                      .percentage
                                  }
                                  %
                                </span>
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#1a1a1a",
                                    fontWeight: "400",
                                  }}
                                >
                                  {
                                    workflows.find((w) => w.id === activeTab)
                                      ?.label
                                  }{" "}
                                  Completed
                                </span>
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  height: "10px",
                                  backgroundColor: "#e0e0e0",
                                  borderRadius: "6px",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    width: `${getWorkflowCompletionPercentages[activeTab].percentage}%`,
                                    height: "100%",
                                    backgroundColor: "#10164D",
                                    borderRadius: "4px",
                                    transition: "width 0.3s ease",
                                  }}
                                />
                              </div>
                            </div>
                          )} */}
                      </div>

                      {/* Inline Filter Panel */}
                      {/* <FilterPanel
                        isOpen={isFilterPanelOpen}
                        onToggle={() =>
                          setIsFilterPanelOpen(!isFilterPanelOpen)
                        }
                        statuses={statuses}
                        activeFilters={activeFilters}
                        onFilterChange={handleFilterClick}
                        filteredData={filteredData}
                        statusesLoading={statusesLoading}
                      /> */}

                      <hr className={styles.saparator} />

                      <div
                        className={styles.all_patients}
                        style={{ height: "510px", overflow: "auto" }}
                      >
                        <Table
                          columns={tableColumns}
                          data={filteredData}
                          height={500}
                          loading={loading}
                          isRowClickable={true}
                          onRowClick={(row) => handlePatientClick(row)}
                          onSort={(sortedData) => {
                            // sortedData is the array after sorting in the table
                            sessionStorage.setItem(
                              "_mdpl",
                              JSON.stringify(sortedData?.map((p) => p?.id))
                            );
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CareManagerDashboard;
